import { Box } from "@mui/material";
import Loading from "@notemeal/shared/ui/global/Loading";
import { TWTabGroup } from "apps/web/src/componentLibrary/TWTabGroup/TWTabGroup";
import React, { useState } from "react";
import { FoodGroupDashboard } from "../../../../components/FoodGroup/Dashboard";
import { DEFAULT_LIMIT, makeUpdateCacheCreateFoodGroup } from "../../../../components/FoodGroup/utils";
import {
  useCreateOrgFoodGroupMutation,
  useEditOrgFoodGroupMutation,
  useOrgFoodGroupsQuery,
  useSharedFoodGroupsQuery,
} from "../../../../types";
import { EntityScope } from "../../../../utils/scope";

export interface FoodGroupDashboardProps {
  scope: EntityScope;
}

export const FoodGroupsPage = () => {
  const orgQueryResult = useOrgFoodGroupsQuery({
    variables: { searchTerm: "", limit: DEFAULT_LIMIT },
  });
  const sharedQueryResult = useSharedFoodGroupsQuery({
    variables: { searchTerm: "", limit: DEFAULT_LIMIT },
  });

  const CUSTOM = "Custom";
  const STANDARD = "Standard";
  const [selected, setSelected] = useState(CUSTOM);
  const buttons = [CUSTOM, STANDARD];

  const [createFoodGroup] = useCreateOrgFoodGroupMutation({});
  const updateCacheCreateFoodGroup = makeUpdateCacheCreateFoodGroup({
    scope: "org",
  });

  const [editFoodGroup] = useEditOrgFoodGroupMutation({});

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", gap: 2 }}>
      <TWTabGroup buttons={buttons} onSelected={selected => setSelected(selected)} />
      {selected === CUSTOM ? (
        !orgQueryResult.data || !!orgQueryResult.loading ? (
          <Loading />
        ) : (
          <FoodGroupDashboard
            editFoodGroup={editFoodGroup}
            createFoodGroup={createFoodGroup}
            updateCacheCreateFoodGroup={updateCacheCreateFoodGroup}
            foodGroups={orgQueryResult.data.orgFoodGroups}
          />
        )
      ) : !sharedQueryResult.data || !!sharedQueryResult.loading ? (
        <Loading />
      ) : (
        <FoodGroupDashboard readOnly foodGroups={sharedQueryResult.data.sharedFoodGroups} />
      )}
    </Box>
  );
};
